var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-card',{staticClass:"px-2 py-3 mt-5 mx-2",attrs:{"elevation":"2"}},[_c('v-card-title',[_c('h4',[_vm._v(" Tablero ")])]),_c('v-card-text',[_c('board-items'),_c('board-attachments')],1)],1),_c('list-materials-by-type',{staticClass:"mx-1",attrs:{"showActions":false,"mainTeams":true,"typesMaterial":_vm.wrappedTypesMaterial}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }